import type { ManagementUser } from '@efdigital/ll-admin-v2/data/builders/users/find-user';
import Component from '@glimmer/component';

interface Signature {
  Args: {
    profile: ManagementUser;
  };
}

export default class UserActivitySection extends Component<Signature> {
  get expiryLabel(): string {
    const { expiryType, expires, expiresAfter, ignoreExpire } =
      this.args.profile;

    if (ignoreExpire) {
      return 'Does not expire';
    }

    switch (expiryType) {
      case 'expires':
        return expires ? `Expires ${expires}` : 'Expires (date not set)';
      case 'expiresAfter':
        return expiresAfter
          ? `Expires after ${expiresAfter} days`
          : 'Expires after inactivity';
      default:
        return 'Expires at end of client subscription';
    }
  }

  formatDate(dateString: string | undefined): string {
    if (!dateString) {
      return '—';
    }

    return new Date(dateString).toLocaleString();
  }

  <template>
    <div class="card mb-4" data-test-user-activity>
      <div class="card-header">
        <h2 class="h5 mb-0">Activity</h2>
      </div>
      <div class="card-body">
        <dl class="row mb-0">
          <dt class="col-sm-3">Login count</dt>
          <dd class="col-sm-9 mb-3">{{@profile.loginCount}}</dd>

          <dt class="col-sm-3">Last login</dt>
          <dd class="col-sm-9 mb-3">
            {{this.formatDate @profile.lastLogin}}
          </dd>

          <dt class="col-sm-3">Created</dt>
          <dd class="col-sm-9 mb-3">
            {{this.formatDate @profile.created}}
          </dd>

          <dt class="col-sm-3">Expiry</dt>
          <dd class="col-sm-9 mb-0">
            {{#if @profile.ignoreExpire}}
              <span class="text-danger">
                <iconify-icon inline icon="ph:warning" />
                Does not expire
              </span>
            {{else}}
              {{this.expiryLabel}}
            {{/if}}
          </dd>
        </dl>
      </div>
    </div>
  </template>
}
